import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from '~/components/core/Atomic/Buttons/Button';
import Grid from '~/components/core/Atomic/Grid/Grid';

import CardDialog from '../CardDialog';
import { ConfirmModal } from '../ConfirmModal';
import LoadingDialog from '../LoadingDialog';
import useDataFetcher from '../useDataFetcher';

import {
  CLAIM_CLOSING_REASON_INITIAL_VALUES,
  ClaimClosingReasonFields,
  getClaimClosingReasonValidationSchema,
  useClaimClosingReasons,
} from './ClaimClosingReasonFormik';

import { useStyles } from '../../assets/styles';

function CloseClaimDialog({ title, claim, onReasonChosen, onClose }) {
  const { classes } = useStyles();
  const { isLoading, isError, reasonDict } = useClaimClosingReasons(claim);
  const {
    isLoading: isCloseRequirementsLoading,
    isError: isCloseRequirementsError,
    data: mandatoryUnansweredFields,
  } = useDataFetcher(`/api/v1/claims/${claim.id}/close_requirements`);

  if (isCloseRequirementsLoading || isCloseRequirementsError) {
    return <LoadingDialog onClose={onClose} isError={isCloseRequirementsError} track="" />;
  }

  if (mandatoryUnansweredFields?.length > 0) {
    const mandatoryUnansweredFieldsDisplayNames = mandatoryUnansweredFields?.map((field) => (
      <>
        <br />
        {field.desc}
      </>
    ));
    return (
      <ConfirmModal
        isOpen={true}
        title="Claim Cannot be Closed"
        contentText={
          <>
            The following details must be filled to close the claim:
            {mandatoryUnansweredFieldsDisplayNames}
          </>
        }
        onClose={onClose}
        primaryButtonName="OK"
        onPrimaryBtnClick={onClose}
        removeSecondaryButton
      />
    );
  }

  return (
    <Formik
      initialValues={CLAIM_CLOSING_REASON_INITIAL_VALUES}
      validationSchema={Yup.object().shape(getClaimClosingReasonValidationSchema(reasonDict))}
      enableReinitialize
      onSubmit={onReasonChosen}
    >
      {(formikProps) => {
        const { isSubmitting, handleSubmit } = formikProps;

        return (
          <CardDialog
            isDialog={true}
            open={true}
            title={title}
            fullWidth
            maxWidth="sm"
            onClose={onClose}
            preventClose={isSubmitting}
          >
            <ClaimClosingReasonFields reasonDict={reasonDict} isLoading={isLoading} isError={isError} />
            <Grid />
            <div className={classes.buttonsContainer}>
              <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit}>
                Close Claim
              </Button>
            </div>
          </CardDialog>
        );
      }}
    </Formik>
  );
}

CloseClaimDialog.propTypes = {
  title: PropTypes.string,
  claim: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onReasonChosen: PropTypes.func.isRequired,
};

export default CloseClaimDialog;
